import React from 'react';
import { observer } from 'mobx-react-lite';
import { styled } from 'dripsy';

import { IRoundImageProps, RoundImage } from './RoundImage';
import { PlaceholderTypeEnum } from './Image';

const Image = styled(RoundImage)({
  bg: '$background20',
});

export interface IAvatarImageProps extends IRoundImageProps {}

export const AvatarImage = observer(
  ({ size = 100, ...props }: IAvatarImageProps) => {
    return (
      <Image
        {...props}
        size={size}
        placeholderType={PlaceholderTypeEnum.Avatar}
      />
    );
  },
);
